import React, { useState } from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Switch from '../../../../../components/input/Switch/Switch';
import Panel from '../../../../../components/outline/Panel';
import RecommendProductDirectSaveInfo from '../RecommendProductDirectSaveInfo';
import RecommendProductSaveNavbar from '../RecommendProductSaveNavbar';
import RecommendProductSaveInfo from '../RecommendProductSaveInfo';
import RecommendProductSaveItemList from '../RecommendProductSaveItemList';
import './RecommendProductSaveWrap.scss';

const RecommendProductSaveWrap = (props) => {
  const {
    form,
    recommendProductSave,
    setData,
    getRecommendProductItemList,
    selectRecommendProductItemList,
    onSubmit,
    onDragEndSelectRecommendProductItemList,
    getRecommendProductItemListExcelDownload,
    getSelectedRecommendProductItemListExcelDownload,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    setRecommendProductItemListExcelUpload,
    typeDisabled,
    getProductSubCategoryList,
    onChangeAttachment,
  } = props;
  const { recommendProductInfo, recommendProductItemList } = recommendProductSave;

  const [directUpload, setDirectUpload] = useState(false);

  return (
    <div className="recommend-product-copy-wrap">
      {/* 하단 네브바 */}
      <RecommendProductSaveNavbar onSubmit={onSubmit} />

      <Panel>
        <div className={`panel-header`}>
          <div className="title">업로드방식</div>
          <div className="description">
            대량의 상품을 엑셀을 통해 업로드 하는 경우 다이렉트 업로드를 사용해주세요. 엑셀 파일을 첨부하여 바로
            업데이트가 가능합니다.
          </div>
        </div>
        <div className="panel-body">
          <BaseForm
            label="다이렉트업로드"
            content={<Switch checked={directUpload} onChange={(value) => setDirectUpload(value)} />}
          />
        </div>
      </Panel>

      {directUpload ? (
        <RecommendProductDirectSaveInfo
          form={form}
          setData={setData}
          recommendProductInfo={recommendProductInfo}
          typeDisabled={typeDisabled}
          onChangeAttachment={onChangeAttachment}
        />
      ) : (
        <>
          <RecommendProductSaveInfo
            form={form}
            setData={setData}
            recommendProductInfo={recommendProductInfo}
            typeDisabled={typeDisabled}
          />

          <RecommendProductSaveItemList
            mainProductCategorySelectList={mainProductCategorySelectList}
            subProductCategorySelectList={subProductCategorySelectList}
            recommendProductItemList={recommendProductItemList}
            getRecommendProductItemList={getRecommendProductItemList}
            selectRecommendProductItemList={selectRecommendProductItemList}
            onDragEndSelectRecommendProductItemList={onDragEndSelectRecommendProductItemList}
            getRecommendProductItemListExcelDownload={getRecommendProductItemListExcelDownload}
            getSelectedRecommendProductItemListExcelDownload={getSelectedRecommendProductItemListExcelDownload}
            setRecommendProductItemListExcelUpload={setRecommendProductItemListExcelUpload}
            getProductSubCategoryList={getProductSubCategoryList}
          />
        </>
      )}
    </div>
  );
};

export default RecommendProductSaveWrap;
